// zh.js
export default {
  stallQualification: {
    title: "摊位资料审核",
    gateHint: "所有摊位须补齐材料并审核通过后才可营业；已有订单可继续履约。",
    refresh: "刷新",
    stallName: "摊位名称",
    stallAddress: "摊位地址",
    nightMarket: "夜市 ID",
    status: "申请状态",
    canOpen: "材料已审核通过",
    yes: "是",
    no: "否",
    draft: "草稿",
    pending: "待审核",
    approved: "已通过",
    rejected: "已驳回",
    notSubmitted: "未提交",
    unknown: "尚未加载",
    responsibleName: "负责人姓名",
    contactPhone: "联系电话",
    identityNumber: "负责人证件号码",
    email: "电子邮箱",
    stallIntroduction: "摊位介绍",
    bankAccountName: "银行账户户名",
    bankName: "银行名称",
    bankAccountNo: "银行账号",
    bankProofImages: "银行账户证明",
    businessRegistrationImages: "营业登记证明（如有）",
    directorScreenshotImages: "董监事资料查询截图（如有）",
    uboDeclarationImages: "实质受益人声明书（如有）",
    identityImages: "负责人证件照片",
    stallImages: "摊位现场照片",
    foodRegistrationNumber: "食品业者登录字号",
    foodRegistrationImages: "食品业者登录证明",
    foodPolicyHint: "食品业者登录字号及证明为选填。",
    saveDraft: "保存草稿",
    submit: "提交审核",
    history: "申请历史",
    version: "申请版本",
    submittedAt: "提交时间",
    reviewedAt: "审核时间",
    rejectReason: "驳回原因",
    actions: "操作",
    detail: "查看详情",
    upload: "上传图片",
    uploadHint: "支持 JPEG / PNG，每张不超过 5 MB，每组最多 5 张。",
    remove: "移除",
    failed: "操作失败，请稍后重试",
    materialsRequired: "请补齐负责人、证件、摊位照片及银行账户资料",
    submitted: "已提交审核",
    saved: "草稿已保存",
    storeId: "摊位 ID",
    search: "查询",
    submittedBy: "提交人 ID",
    reviewedBy: "审核人 ID",
    reasonPlaceholder: "驳回时必须填写原因，最多 500 字",
    approve: "审核通过",
    reject: "驳回",
    reasonRequired: "请填写驳回原因",
    reviewed: "审核结果已保存"
  },
	dongtai: {
		daishouli: '待受理',
		daichuchan: '待出餐',
		yichuchan: '已出餐',
		yiwancheng: '已完成',
		Canceled: '已取消',
		shouhou: '退款/售后',
		all: '全部',
		waisong: '外卖',
		tangs: '堂食',
		ziqu: '自取',
	},
	loding: {
		language: 'zh-CN',
		lass: 'zh',
		cte: '美食达商户管理',
		lang: '选择语言',
		username: '用户名',
		pasd: '密码',
		logng: '登录',
		txuse: '请填写用户名',
		txpad: '请填写密码'
	},
	route: {
		cte: '美食达',
		home: '首页',
		mdguanli: '门店管理',
		mdlist: '门店列表',
		mdfenlei: '商品分类',
		spguanli: '商品管理',
		biaoti: '欢迎使用美食达商户平台',
		degnlu: '退出登录',
		qttuicu: '确定要退出登录吗?',
		tishi: '提示',
		tued: '确定',
		quxiao: '取消',
		yuiquangl: '优惠券管理',
		zxhd: '促销活动管理',
		quanyi: '可用优惠券',
		ddpl: '订单评论',

	},
	index: {
		newdd: '最新订单',
		ddid: '订单号',
		invoice: '发票',
		invoiceNone: '无',
		invoiceIssued: '已开票',
		invalidBtn: '作废',
		invalidReason: '作废原因',
		invalidOk: '已作废',
		cretim: '下单时间',
		amount: '订单金额',
		address: '配送地址',
		jvli: '配送距离',
		ddodr: '订单商品',
		type: '订单类型',
		tangs: '堂食',
		ziqu: '自取',
		waisong: '外送',
		collectPayment: '到付订单',
		yes: '是',
		nos: '否',
		right: '操作',
		chak: '查看',
		jiedan: '接单',
		chucan: '出餐',
		tishi: '提示',
		tisiyu: '你确定要操作订单吗?',
		quxiao: '取消',
		qued: '确定',
		xiangq: '详情',
		freight: '配送费',
		qishou: '接单骑手',
		foods: '订单商品',
		guanbi: '关闭',
		shus: '商户',
		sqsu: '骑手',
		user: '用户',
		dpshu: '店铺数',
		ddsour: '当日收入',
		dddingd: '当日订单',
		zongsr: '总收入',
		zddlng: '总订单量',
		ketixan: '可提现金额',
		beizu: '备注',
		cxhdxx: "促销活动信息",
		ptcxhd: "平台促销活动",
		sjcxhd: "商家促销活动",
		jm: "减免",
		yhqxx: "优惠券信息",
		ptyhq: "平台优惠券",
		sjyhq: "商家优惠券",
		yhje: "优惠金额",
		none: "无",
		export: '导出',
		jfsyqk: '积分使用情况',
		jfsysl: '使用积分数量',
		jfdkje: '抵扣金额',
		startTime: '开始时间',
		endTime: '结束时间',
		payType: '支付方式',
		CashOnDelivery: '货到付款',
		OfflineTransfer: '线下转账',
		OMG: 'OMG',
		LinePay: 'Line Pay',
		cash: '现金',
		wancheng: '完成',
	},
	mendian: {
		UBN: '统一编号',
		EnterUBN: '请输入统一编号',
		UBNFormatError: '统一编号需为8位数字',
		home: '首页',
		Management: '门店管理',
		StoreList: '门店列表',
		AddStore: '添加门店',
		logo: '商标',
		StoreCover: '门店封面',
		StoreName: '门店名称',
		Startingprice: '起送价',
		openBusiness: '开始营业',
		windingUp: '结束营业',
		area: '所在地区',
		Telephone: '客服电话',
		operate: '操作',
		modify: '修改',
		delete: '删除',
		Enterstorename: '请输入店名称',
		address: '地址',
		InputAddress: '请输入店地址',
		coordinate: '坐标',
		Positioningobtaincoordinates: '请点击定位图标获取门店坐标',
		Storetype: '门店类型',
		Restaurant: '餐饮',
		Supermarket: '商超',
		Fillintheprice: '填写起送价格',
		Fillphonenumber: '填写客服电话',
		FillopenBusiness: '填写开始营业时间，例：8:00',
		FillwindingUp: '填写结束营业时间，例：18:00',
		classification: '分类',
		Pleaseselect: '请选择',
		ServiceType: '服务类型',
		Fooddelivery: '美食外送',
		Dinein: '堂食',
		Selfpickuptakeout: '外卖自取',
		Summericedrink: '夏日冰饮',
		Exquisiteafternoontea: '精致下午茶',
		state: '状态',
		trade: '营业',
		close: '打烊',
		determine: '确定',
		cancellation: '取消',
		selectaddress: '选择地址',
		Covercannotempty: '门店封面不能为空',
		Namecannotempty: '门店名称不能为空',
		Addresscannotempty: '门店地址不能为空',
		Coordinatescannotempty: '坐标不能为空',
		openBusinesscannotempty: '开始营业时间不能为空',
		windingUpcannotempty: '结束营业时间不能为空',
		Classifiedmandatory: '分类为必选项',
		Selectservicetype: '至少要选择一个服务类型',
		prompt: '提示',
		youwanttodeleteit: '你确定要删除此门店吗?',
		successful: '删除成功',
		Deletefailed: '失败，请重试',
		undelete: '已取消删除',
		ModifyStore: '修改门店',
		Selectmapobtainaddress: '请点选地图获取地址',
		ItcanonlyJPG: '上传头像图片只能是 JPG 格式!',
		Cannotexceed: '上传头像图片大小不能超过 2MB!',
		SearchAddress: '搜索地址',
		Pleasekeywords: '请输入关键字',
		currentlocation: '当前位置',
		openingtime: '营业时间',
		addTime: '新增时间段',
		zssjd: '请至少添加一个营业时间段',
		mgsjd: '每个时间段都需填写开始和结束时间',
		Monday: '星期一',
		Tuesday: '星期二',
		Wednesday: '星期三',
		Thursday: '星期四',
		Friday: '星期五',
		Saturday: '星期六',
		Sunday: '星期日',
		noTimeSlotWarning: '请先添加时间段再开启该天',

		Selectbusinessday: '批量设置',
		businessday: '营业天',
		Enteropeningtime: '请添加营业时间',
		Enterbusinessday: '请选择营业天',
		menuPhoto: '菜单照片',
		menuPhoto2: '请上传菜单照片',

	},
	fenlei: {
		home: '首页',
		Management: '门店管理',
		CATEGORY: '商品分类',
		Addcategory: '添加商品分类',
		Classiname: '分类名称',
		operate: '操作',
		modify: '修改',
		delete: '删除',
		Plearname: '请输分类名称',
		determine: '确定',
		cancellation: '取消',
		Classifyempty: '分类名不能为空',
		successfully: '提交成功!',
		Modifyclass: '修改分类',
		prompt: '提示',
		DeleteCategory: '你确定要删除此分类吗?',
		successful: '删除成功',
		Deletefailed: '失败，请重试',
		undelete: '已取消删除',
		id: 'id',
		sodi: '请输入排序id,数字越大越靠前'
	},
	imageCrop: {
		title: '裁剪图片',
		hint: '拖动裁剪框调整位置，拖动右下角调整大小（正方形）',
		cancel: '取消',
		confirm: '确认裁剪并上传',
		invalidType: '请选择图片文件',
		tooLarge: '上传图片大小不能超过 {size} MB',
		readFailed: '图片读取失败，请重新选择',
		cropFailed: '图片裁剪失败，请重试',
		uploadFailed: '图片上传失败',
		networkFailed: '图片上传失败，请检查网络后重试'
	},
	foots: {
		home: '首页',
		Management: '门店管理',
		Commodityfood: '商品管理',
		classification: '分类',
		addproduct: '添加商品',
		Tradename: '商品名称',
		Commoditypicture: '商品图片',
		commodityprice: '商品价格',
		illustrate: '说明',
		operate: '操作',
		modify: '修改',
		delete: '删除',
		Enterproductname: '请输入商品名称',
		Enterproductprice: '请输入商品价格',
		Attributes: '商品属性',
		AddType: '添加类型',
		EditType: '编辑类型',
		Radio: '单选',
		multiplechoice: '多选',
		optional: '可选',
		required: '必选',
		Introduction: '商品介绍',
		EnterIntroduction: '请输入商品介绍',
		Dorecommendit: '是否推荐',
		Productsorting: '商品排序',
		Anynumber: '填任何数值,值大排在前',
		determine: '确定',
		cancellation: '取消',
		typename: '类型名称',
		InputMerchantType: '请输入商品类型',
		Multiplechoices: '是否多选',
		Isitmandatory: '是否必选',
		Addspecifications: '添加规格',
		Addspecifications2: '编辑规格',
		formname: '规格名称',
		Entercationname: '请输入规格名称',
		Specificationprice: '规格价格',
		Enterandprices: '请输入规格价格',
		description: '规格说明',
		Entercationiption: '请输入规格说明',
		Imagebeempty: '图片不能为空',
		Namebeempty: '名称不能为空',
		Pricebeempty: '价格不能为空',
		Thenamebeempty: '规格名不能为空',
		Typenamebeempty: '类型名不能为空',
		prompt: '提示',
		Confirmdeletion: '你确定要删除商品类型吗?',
		Unabletodelete: '此类型存在规格,无法删除',
		DeleteSpecification: '你确定要删除商品规格吗?',
		Modifyproduct: '修改商品',
		Deletethisproduct: '你确定要删除此商品吗?',
		successful: '删除成功',
		Deletefailed: '失败，请重试',
		undelete: '已取消删除',
		ItcanonlyJPG: '上传头像图片只能是 JPG 格式!',
		Cannotexceed: '上传头像图片大小不能超过 2MB!',
		search: '查询',
		reset: '重置',
		AddCategoryFirst: '请先添加商品分类再添加商品',
		AddCategoryFirst2: '请先添加门店再添加商品分类',
	},
	cuxiao: {
		home: '首页',
		yuiquangl: '优惠券管理',
		zxhd: '促销活动管理',
		AddCX: '新增',
		hdmc: '活动名称',
		hdmcms: '请输入促销活动名称',
		hdhb: '活动海报',
		qmfs: '减免方式',
		qmyf: '运费',
		ddjdz: '订单',
		ddjdk: '商品',
		qmz: '减免值',
		qmzsm: '免运费填0,如选打折如7折请填0.7,如选抵扣1000请填1000',
		sytj: '使用条件',
		sytjsm: '如空为无任何使用条件,如填1000为订单金额满1000可用',
		salesFund: '可用次数',
		salesFundsm: '如空值为无限使用,如填1为此活动每个用户只能使用一次',
		endTime: '结束日期',
		endTimesm: '请选择活动结束日期',
		salesState: '活动状态',
		salesStateKq: '开启',
		salesStateTy: '停用',
		illustrate: '活动说明',
		illustratesm: '请输入内容',
		jsrq: '结束日期',
		hdzt: '活动状态',
		operate: '操作',
		modify: '修改',
		delete: '删除',
		hdmcEpty: '活动名不能空',
		qmfsEmty: '减免方式为必选',
		endTimeEmty: "结束日期为必选",
		salesStateEmty: "活动状态为必选",
		salesReductionEmty: '减免值为必填',
		salesReduction0: '减免方式选择订单、商品值必须大于0',
		delSm: '是否确认删除该记录吗？',
		ItcanonlyJPG: '上传图片只能是 JPG 格式!',
		Cannotexceed: '上传图片大小不能超过 2MB!',
		bnxg: '该促销活动已有用户使用,只能修改状态，不能修改其他核心字段',
	},
	quanyi: {
		kyyhq: '可用优惠券',
		add: '新增',
		yhmc: '优惠券名称',
		yhfs: '优惠方式',
		sm: '说明',
		sytj: '使用条件',
		zt: '状态',
		qy: '启用',
		gb: '关闭',
		yhqlx1: '运费',
		yhqlx2: '订单',
		yhqlx3: '商品',
		yhqlx4: '减免个别商品',
		total: '优惠券总数',
		creatTime: '创建时间',
		sryhmc: '请输入优惠券名称',
		yhnum: '优惠值',
		sryhnum: '免运费填写0,如选打折如7折请填0.7,如选抵扣1000请填1000',
		yhmnum0: '选择订单、商品输入值必须大于0',
		srtotal: '请输入优惠券总数',
		lqxz: '每人能领取数量',
		srlqxz: '请输入每人能领取的数量',
		validity: "有效期限（天）",
		srvalidity: '请输入有效期',
		shuoming: '说明',
		srshuoming: '请输入说明',
		tiaojian: '使用条件',
		srtiaojian: '请输入使用条件，0为无门槛，大于0为消费满金额可用',
		nameEpty: '优惠券名称不能为空',
		yhfangsEmpty: '请选择优惠方式',
		yhnumEmty: '优惠值不能为空',
		totalEmty: '优惠券总数不能为空',
		lqxzEmty: '每人能领取的数量不能为空',
		validityEmty: '有效天数不能为空',
		stateEmty: '请选择状态',
		xcsp: '选择商品',
		qxcsp: '请选择商品',
		md: "门店：",
		xcmd: "选择门店",
		spfl: '商品分类：',
		spmc: '商品名称：',
		cx: '查询',
		tp: '图片',
		jg: '价格',
		qx: '取消',
		qd: '确定',
		ItcanonlyJPG: '上传图片只能是 JPG 格式!',
		Cannotexceed: '上传图片大小不能超过 2MB!',
		bnxg: '已有用户领取了该优惠券，只能修改状态，无法修改其他核心字段',
		claimedCount: '已领取数量',
	},
	review: {
		ddid: '订单id',
		srddid: '请输入订单id',
		plsj: '评论时间',
		cz: '操作',
		sc: '删除',
		ck: '查看',
		yhid: '用户id',
		pf: '评分',
		plnr: '评论内容',
		sfnm: '是否匿名',
		yes: '是',
		no: '否',
		pltp: '评论图片',
		ddpl: '订单评论',
	},
	Aside: {
		text1: '摊位管理',
		text2: '摊位列表',
		selfDeliverySettings: '自配送设置',
		text3: '餐桌管理',
		text4: '餐桌码管理',
		text5: '财务管理',
		text6: '账单管理',
	},
	TableQRCode: {
		text1: '类型',
		text2: '全部',
		text3: '私用码',
		text4: '公用码',
		text5: '状态',
		text6: '启用',
		text7: '停用',
		text8: '查询',
		text9: '新建餐桌码',
		text10: '桌号',
		text11: '停用',
		text12: '所属门店/摊位',
		text13: '使用状态',
		text14: '空闲',
		text15: '使用中',
		text16: '启用状态',
		text17: '创建时间',
		text18: '操作',
		text19: '查看二维码',
		text20: '编辑',
		text21: '删除',
		text22: '桌号',
		text23: '请输入桌号，如 A01',
		text24: '请选择门店/摊位',
		text25: '备注',
		text26: '请输入备注',
		text27: '取消',
		text28: '确定',
		text29: '选择门店/摊位',
		text30: '搜索名称/地址',
		text31: '门店/摊位名称',
		text32: '地址',
		text33: '电话',
		text34: '餐桌二维码',
		text35: '桌号：',
		text36: '加载中...',
		text37: '关闭',
		text38: '下载',
		text39: '请输入桌号',
		text40: '请选择类型',
		text41: '请选择摊位',
		text42: '获取列表失败',
		text43: '编辑餐桌码',
		text44: '更新成功',
		text45: '更新失败',
		text46: '创建成功',
		text47: '创建失败',
		text48: '确认删除该餐桌码？',
		text49: '提示',
		text50: '删除成功',
		text51: '删除失败',
		text52: '操作成功',
		text53: '操作失败',
		text54: '获取二维码失败',
		text55: '订单',
		text56: '餐桌订单 - ',
		text57: '订单状态',
		text58: '待处理',
		text59: '进行中',
		text60: '已完成/已关闭',
		text61: '订单号',
		text62: '金额',
		text63: '出餐状态',
		text64: '下单时间',
		text65: '已出餐',
		text66: '未出餐',
		text67: '已付款',
		text68: '已接单',
		text69: '配送中',
		text70: '已送达',
		text71: '已取消',
		text72: '退款中',
		text73: '已退款',
		text74: '退款拒绝',
		text75: '已评价',
		text76: '未知',
		text77: '获取订单失败',

		text78: '待接单',
		text79: '制作中',
		text80: '备餐完成',
		text81: '已完成',
		text82: '备注',
		text83: '首页',
		text84: '餐桌码管理',
	},
	StallManage: {
		text1: '创建摊位',
		text2: '摊位名称',
		text3: '地址',
		text4: '电话',
		text5: '简介',
		text6: '创建时间',
		text7: '操作',
		text8: '管理摊位主',
		text9: '编辑',
		text10: '摊位名称',
		text11: '请输入摊位名称',
		text12: '请输入地址',
		text13: '请输入联系电话',
		text14: '请输入简介',
		text15: '取消',
		text16: '确定',
		text17: '摊位主管理',
		text18: '添加摊位主',
		text19: '昵称',
		text20: '手机号',
		text21: '状态',
		text22: '正常',
		text23: '禁用',
		text24: '启用',
		text25: '删除',
		text26: '请输入手机号',
		text27: '密码',
		text28: '请输入密码',
		text29: '昵称',
		text30: '请输入昵称',
		text31: '操作失败',
		text32: '获取摊位列表失败',
		text33: '创建摊位',
		text34: '编辑摊位',
		text35: '操作成功',
		text36: '操作失败',
		text37: '添加成功',
		text38: '添加失败',
		text39: '已禁用',
		text40: '已启用',
		text41: '确认删除该摊位主？',
		text42: '提示',
		text43: '已删除',
		text44: '删除失败',
		text45: '请输入用户名',
		ownerPassword: '密码',
		editOwnerTitle: '编辑摊位主',
		editOwnerPasswordKeep: '不修改密码请留空',
	},
	tableQrcode: {
		orderBtn: '订单',
		orderDialogTitle: '餐桌订单 - ',
		orderStatus: '订单状态',
		orderAll: '全部',
		orderPending: '待处理',
		orderInProgress: '进行中',
		orderCompleted: '已完成/已关闭',
		orderNo: '订单号',
		orderAmount: '金额',
		orderState: '订单状态',
		diningStatus: '出餐状态',
		orderTime: '下单时间',
		diningDone: '已出餐',
		diningNotDone: '未出餐',
		state0: '待处理',
		state1: '已付款',
		state2: '已接单',
		state3: '配送中',
		state4: '已送达',
		state6: '已取消',
		state7: '退款中',
		state8: '已退款',
		state9: '退款拒绝',
		state11: '已评价',
		stateUnknown: '未知',
		getOrderFailed: '获取订单失败',
	}
	,
	promoMenu: {
		title: '营销管理',
		activity: '促销活动',
		coupon: '优惠券管理'
	},
	promoActivity: {
		home: '首页',
		marketing: '营销管理',
		title: '促销活动',
		all: '全部',
		notStarted: '未开始',
		ongoing: '进行中',
		ended: '已结束',
		addActivity: '新增活动',
		activityName: '活动名称',
		activityType: '活动类型',
		typeManjian: '满减',
		typeZhekou: '折扣商品',
		typeHalfPrice: '第二份半价',
		typeNewUser: '新客立减',
		status: '状态',
		startTime: '开始时间',
		endTime: '结束时间',
		operate: '操作',
		endBtn: '结束',
		tabManjian: '满减活动',
		pleaseInputName: '请输入活动名称',
		activityTime: '活动时间',
		ruleTiers: '规则档位',
		full: '满',
		fullAmount: '金额',
		reduce: '减',
		reduceAmount: '减免金额',
		yuan: '元',
		deleteTier: '删除',
		addTier: '添加档位',
		tabZhekou: '折扣商品',
		discountRate: '折扣率',
		productName: '商品名称',
		productPrice: '价格',
		remove: '移除',
		addProduct: '添加商品',
		tabHalfPrice: '第二份半价',
		productImage: '图片',
		selectProduct: '选择商品',
		tabNewUser: '新客立减',
		save: '保存',
		cancel: '取消',
		category: '商品分类',
		selectCategory: '选择分类',
		keyword: '关键词',
		search: '搜索',
		add: '添加',
		endConfirm: '确认结束该活动？结束后不可恢复。',
		prompt: '提示',
		confirm: '确定',
		productExists: '该商品已存在',
		pleaseSelectTime: '请选择活动时间',
		pleaseCompleteRules: '请完善满减规则',
		pleaseCompleteDiscount: '请输入折扣率',
		pleaseSelectProducts: '请选择商品',
		pleaseInputReduce: '请输入减免金额',
		addSuccess: '新增成功',
		operateSuccess: '操作成功',
		operateFail: '操作失败',
		editBtn: '编辑',
		deleteBtn: '删除',
		editActivity: '编辑活动',
		createActivity: '新增活动',
		deleteConfirm: '确认删除该活动？删除后不可恢复。',
		editSuccess: '修改成功',
		deleteSuccess: '删除成功',
		alreadyAdded: '已添加',
		discountedPrice: '折后价',
		originalPrice: '原价',
		addDiscountProduct: '添加折扣商品',
		productAlreadyAdded: '商品已添加，请勿重复选择',
		discountRateRange: '折扣率范围10%-99%',
		pleaseSelectProduct: '请先选择商品'
	},
	couponBatch: {
		pageTitle: '优惠券管理', createBtn: '新增优惠券', offShelfBtn: '下架',
		offShelfConfirm: '确认下架该优惠券？已领取的券仍可使用。', couponName: '券名称',
		couponType: '券类型', totalCount: '发放总量', remainCount: '剩余', receivedCount: '已领取',
		validDays: '有效天数', validDaysUnit: '天（领取后计算）', receiveTime: '领取时间',
		status: '状态', statusAll: '全部', statusNotStarted: '未开始', statusActive: '进行中',
		statusEnded: '已结束', statusOffShelf: '已下架', typeManjian: '满减券', typeProduct: '商品券',
		mutexLabel: '叠加属性', mutexShare: '同享券（可与促销叠加）', mutexExclusive: '互斥券（不可与促销叠加）',
		threshold: '使用门槛', thresholdUnit: '元', amount: '减免金额', amountUnit: '元',
		selectProduct: '选择商品', discountRate: '折扣率', discountRateUnit: '%（如70表示7折）',
		saveBtn: '保存', cancelBtn: '取消', storeLabel: '门店', timeRange: '领取时间',
		nameRequired: '请输入券名称', timeRequired: '请选择领取时间',
		totalRequired: '请输入发放总量', validDaysRequired: '请输入有效天数', amountRequired: '请输入金额',
		marketing: '营销管理',
		startTime: '领取开始时间',
		endTime: '领取结束时间',
		days: '天',
		offShelfSuccess: '下架成功',
		offShelfFail: '下架失败',
		couponNamePlaceholder: '请输入券名称',
		selectStore: '选择门店',
		typeRequired: '请选择券类型',
		storeRequired: '请选择门店',
		thresholdRequired: '请输入使用门槛',
		discountRequired: '请输入折扣率',
		productRequired: '请选择商品',
		addSuccess: '新增成功',
		addFail: '新增失败',
		category: '商品分类',
		selectCategory: '选择分类',
		keyword: '搜索',
		productName: '商品名称',
		search: '查询',
		image: '图片',
		price: '价格',
		add: '添加',
		editBtn: '编辑',
		deleteBtn: '删除',
		editCoupon: '编辑优惠券',
		createCoupon: '新增优惠券',
		deleteConfirm: '确认删除该优惠券？删除后不可恢复。',
		typeFreeDelivery: '免配送费券',
		deleteSuccess: '删除成功',
		deleteFail: '删除失败',
		editSuccess: '修改成功',
		editFail: '修改失败',
		remove: '移除',
		productExists: '商品已添加，请勿重复添加',
		alreadyAdded: '已添加'
	},

	foots: {
		home: '首页',
		Management: '门店管理',
		Commodityfood: '商品管理',
		classification: '分类',
		addproduct: '添加商品',
		Tradename: '商品名称',
		Commoditypicture: '商品图片',
		commodityprice: '商品价格',
		illustrate: '说明',
		operate: '操作',
		modify: '修改',
		delete: '删除',
		Enterproductname: '请输入商品名称',
		Enterproductprice: '请输入商品价格',
		Attributes: '商品属性',
		AddType: '添加类型',
		Radio: '单选',
		multiplechoice: '多选',
		optional: '可选',
		required: '必选',
		Introduction: '商品介绍',
		EnterIntroduction: '请输入商品介绍',
		Dorecommendit: '是否推荐',
		Productsorting: '商品排序',
		Anynumber: '填任何数值,值大排在前',
		determine: '确定',
		cancellation: '取消',
		typename: '类型名称',
		InputMerchantType: '请输入商品类型',
		Multiplechoices: '是否多选',
		Isitmandatory: '是否必选',
		Addspecifications: '添加规格',
		formname: '规格名称',
		Entercationname: '请输入规格名称',
		Specificationprice: '规格价格',
		Enterandprices: '请输入规格价格',
		description: '规格说明',
		Entercationiption: '请输入规格说明',
		Imagebeempty: '图片不能为空',
		Namebeempty: '名称不能为空',
		Pricebeempty: '价格不能为空',
		Thenamebeempty: '规格名不能为空',
		Typenamebeempty: '类型名不能为空',
		prompt: '提示',
		Confirmdeletion: '你确定要删除商品类型吗?',
		Unabletodelete: '此类型存在规格,无法删除',
		DeleteSpecification: '你确定要删除商品规格吗?',
		Modifyproduct: '修改商品',
		Deletethisproduct: '你确定要删除此商品吗?',
		successful: '删除成功',
		Deletefailed: '失败，请重试',
		undelete: '已取消删除',
		ItcanonlyJPG: '上传头像图片只能是 JPG 格式!',
		Cannotexceed: '上传头像图片大小不能超过 2MB!',
		search: '查询',
		reset: '重置',
		// 售卖时间相关翻译
		sellingTime: '售卖时间',
		wholeDay: '整天',
		wholeDayDesc: '开启后商品将按照店面营业时间售卖',
		startTime: '开始时间',
		endTime: '结束时间',
		addTimeSlot: '添加时段',
		pleaseSetSellingTime: '请设置售卖时间',
		enabledDaysMustSetTimeSlots: '启用天数必须设置时间段',
		timeSlotsMustBeComplete: '时间段必须填写完整',
		pleaseAddTimeSlotsFirst: '请先添加时间段再开启该天',
		Monday: '星期一',
		Tuesday: '星期二',
		Wednesday: '星期三',
		Thursday: '星期四',
		Friday: '星期五',
		Saturday: '星期六',
		Sunday: '星期日'
	},
	subaccount: {
		menu: '分管账号',
		title: '分管账号管理',
		description: '为一个账号分配多个负责店铺，账号无需切换当前店铺。',
		create: '新增分管账号',
		name: '姓名',
		phone: '手机号',
		stores: '负责店铺',
		noStores: '暂无负责店铺',
		accountStatus: '账号状态',
		ownerEnabled: '主账号已启用',
		ownerDisabled: '主账号已停用',
		platformEnabled: '平台正常',
		platformDisabled: '平台已停用',
		online: '在线状态',
		onlineYes: '在线',
		onlineNo: '离线',
		lastLogin: '最近登录',
		actions: '操作',
		edit: '编辑',
		resetPassword: '重置密码',
		disableOwner: '禁用',
		enableOwner: '启用',
		editTitle: '编辑分管账号',
		createTitle: '新增分管账号',
		password: '密码',
		namePlaceholder: '请输入姓名',
		phonePlaceholder: '请输入登录手机号',
		passwordPlaceholder: '请输入密码',
		storePlaceholder: '请选择负责店铺',
		platformDisabledHint: '该账号已被平台停用，主账号启用不会解除平台限制。',
		cancel: '取消',
		save: '保存',
		nameRequired: '请输入姓名',
		phoneRequired: '请输入手机号',
		passwordRequired: '请输入密码',
		storeRequired: '请至少选择一家店铺',
		saved: '保存成功',
		resetPasswordTitle: '重置分管账号密码',
		newPassword: '新密码',
		confirmReset: '确认重置',
		passwordReset: '密码已重置，原登录会话已失效',
		ownerEnabledResult: '已设置为主账号启用',
		ownerDisabledResult: '已设置为主账号停用',
		platformStillDisabled: '平台停用状态仍然有效'
	},
	spec: {
		spec: '商品规格',
		addSpec: '添加规格',
		specCategory: '规格类型',
		specCategoryEmpty: '规格类型不能为空',
		isOpen: '是否启用',
		detail: '规格明细',
		addDetail: '添加明细',
		editDetail: '编辑明细',
		detailEmpt: '请添加规格明细',
		modifySpec: '修改规格',
		tryAgain: '保存失败，请重试',
		excuteSuccess: '执行成功',
		excuteFail: '执行失败，请重试',
		openSpec: '启用',
		atLeastOneDetailEnabled: '规格启用时，至少需要启用一项明细'
	},
	menuCopy: {
		entry: '从其他门店复制',
		title: '复制商品',
		description: '当前门店是目标门店。请选择来源门店，系统会先预览分类和商品差异。',
		targetStore: '目标门店',
		sourceStore: '来源门店',
		selectSource: '请选择来源门店',
		addedCategories: '新增分类',
		mergedCategories: '合并分类',
		addedProducts: '新增商品',
		identicalProducts: '一致跳过',
		differentProducts: '差异商品',
		alreadySynced: '两家门店的菜单已经一致，无需复制。',
		differenceDetails: '差异明细',
		changedField: '差异字段',
		targetValue: '本店当前值',
		sourceValue: '来源店值',
		conflictStrategy: '差异处理',
		keepTarget: '保留本店版本',
		overwriteTarget: '用来源店版本覆盖',
		overwriteWarning: '覆盖只更新商品内容和规格关联，不改变本店商品的上下架及审核状态。',
		cancel: '取消',
		confirm: '确认复制',
		operationFailed: '操作失败，请重试。',
		successSummary: '复制完成：新增分类 {categories} 个、商品 {products} 个，跳过 {skipped} 个，覆盖 {overwritten} 个。',
		emptyValue: '空',
		fieldNames: {
			price: '价格', image: '图片', introduce: '介绍', foodSku: '属性', sort: '排序', recommend: '推荐', specs: '规格'
		},
		languages: { '0': '越南语', '1': '英语', '2': '简体中文', '3': '繁体中文' }
	},

	payMethod: {
		remarkTitle: '支付方式说明',
		pageTitle: '支付设置',
		methodSectionTitle: '接受的支付方式',
		methodTip: '不勾选任何方式时，将接受全部可用支付方式；平台关闭的方式对买卖双方同时失效。',
		save: '保存',
		saveSuccess: '保存成功',
		cancel: '取消',
		groupCod: '到付',
		groupCash: '现金',
		groupCard: '信用卡 / Apple Pay',
		groupLinePay: 'LINE Pay',
		groupOffline: '线下转账',
		bankSectionTitle: '收款银行卡',
		bankTip: '付款方仅能看到当前启用的银行卡；启用新卡将自动停用旧卡；线下转账需要至少一张启用的银行卡。',
		bankName: '银行名称',
		accountNo: '银行账号',
		accountName: '户名',
		activeState: '状态',
		active: '已启用',
		inactive: '未启用',
		action: '操作',
		enable: '启用',
		edit: '编辑',
		delete: '删除',
		addCard: '新增银行卡',
		editCard: '编辑银行卡',
		pleaseSelectBank: '请选择银行',
		deleteConfirm: '确定删除该银行卡吗？',
		tip: '提示',
		cashScopeHint: '仅自取、堂食订单可用',
		notReadyTip: '未就绪的支付方式勾选后用户端也不会显示；信用卡 / LINE Pay 需联系平台开通凭证，线下转账需先新增并启用银行卡。',
		notReadyTag: '未就绪',
	},
	selfDelivery: {
	menu: '自配送设置',
	pageTitle: '自配送设置',
	effectTip: '该配置对旗下所有摊位统一生效：命中时段的外送订单不进入骑手接单池，由夜市自行配送；未开启或未命中时段的订单仍由骑手正常配送。',
	enableSwitch: '开启自配送',
	modeLabel: '配送模式',
	modeAllDay: '全天自配送',
	modeCustom: '自定义时段',
	customTip: '按星期设置时段；时段含开始时刻、不含结束时刻',
	addRange: '添加时段',
	removeRange: '删除',
	startTime: '开始时间',
	endTime: '结束时间',
	monday: '周一',
	tuesday: '周二',
	wednesday: '周三',
	thursday: '周四',
	friday: '周五',
	saturday: '周六',
	sunday: '周日',
	saveBtn: '保存',
	saveSuccess: '保存成功',
	loadFail: '加载配置失败',
	saveFail: '保存失败',
	invalidRange: '存在不完整的时段，或结束时间未晚于开始时间',
	noRangeTip: '自定义模式下至少需要设置一个时段',
	freightBilling: '自配送运费'
	}
}
